var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "url(#paint0_linear_2_331)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3485 21.9439V31.3484M31.3485 31.3484V40.7529M31.3485 31.3484H40.753M31.3485 31.3484H21.944",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_331",
    x1: 7.68142,
    y1: 4.87477e-7,
    x2: 48.2832,
    y2: 55.4159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E8EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444BAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStory);
export default __webpack_public_path__ + "static/media/addStory.65d6632e32e7fb5ea2175e827b1b8006.svg";
export { ForwardRef as ReactComponent };